'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlexGridLayer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;
// see: https://github.com/STRML/react-grid-layout


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactGridLayout = require('react-grid-layout');

var _reactGridLayout2 = _interopRequireDefault(_reactGridLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FlexGridLayer = exports.FlexGridLayer = (_temp2 = _class = function (_React$PureComponent) {
  _inherits(FlexGridLayer, _React$PureComponent);

  function FlexGridLayer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FlexGridLayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FlexGridLayer.__proto__ || Object.getPrototypeOf(FlexGridLayer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      width: 800
    }, _this._nextVectors = [], _temp), _possibleConstructorReturn(_this, _ret);
  }
  // static providers = ['resizer'];

  _createClass(FlexGridLayer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      /* eslint-disable react/no-find-dom-node */
      var dom = _reactDom2.default.findDOMNode(this);
      this.setState({
        width: dom.offsetWidth
      }, function () {
        if (_this2.context.resizer) {
          _this2._cancelResize = _this2.context.resizer.resize(dom, function () {
            _this2.setState({
              width: dom.offsetWidth
            });
          });
        }
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._cancelResize && this._cancelResize();
    }
  }, {
    key: 'getGridVector',
    value: function getGridVector(vectors) {
      if (this._nextVectors.length) {
        return this._nextVectors.shift();
      }
      var precedent = !!vectors[0];
      // 一行分6个
      var count = 12;
      // 所有高度
      var hArr = new Array(count);
      // x轴只判断一遍
      var xArr = [];
      // 最低高度
      var minHeight = precedent ? count : 0;
      // 最低高度的下标
      var minHkey = 0;
      var tmpHeight = void 0;
      for (var i = vectors.length; i--;) {
        tmpHeight = vectors[i].y + vectors[i].h;
        if (tmpHeight <= minHeight && !xArr[vectors[i].x]) {
          minHeight = tmpHeight;
          minHkey = i;
          xArr[vectors[i].x] = true;
        }
        // 首行占用了多少位置
        if (vectors[i].y === 0) {
          for (var j = 0; j < vectors[i].w; j++) {
            hArr[vectors[i].x + j] = true;
          }
        }
      }
      var minH = 3;
      var minW = 4;
      var k = 0;
      // 已占有2个宽度为准
      var fWidth = 0;
      // 有占用时的下标
      var fWkey = 0;
      if (hArr.length) {
        while (fWkey < count) {
          if (hArr[fWkey]) {
            fWkey++;
          } else {
            while (k < minW) {
              if (fWkey + k < count && !hArr[fWkey + k]) {
                fWidth++;
              }
              k++;
            }
            break;
          }
        }
      }
      // 未占满
      var vector = void 0;
      if (fWidth === minW) {
        vector = { x: fWkey, y: 0, w: fWidth, h: minH };
      } else if (precedent) {
        // 重要，如果一个模块下，可以容纳2个，那么就加入2个
        var mults = Math.floor(vectors[minHkey].w / minW);
        if (mults > 1) {
          vector = { x: vectors[minHkey].x, y: minHeight, w: minW, h: minH };
          for (var z = 1; z < mults; z++) {
            this._nextVectors.push({ x: vectors[minHkey].x + minW * z, y: minHeight, w: minW * z, h: minH });
          }
        } else {
          vector = { x: vectors[minHkey].x, y: minHeight, w: vectors[minHkey].w, h: minH };
        }
      } else {
        vector = { x: 0, y: 0, w: minW, h: minH };
      }
      return vector;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          components = _props.components,
          LayerItem = _props.LayerItem,
          onLayerChange = _props.onLayerChange,
          autoGrid = _props.autoGrid,
          isResizable = _props.isResizable,
          style = _props.style;

      var editable = this.context.layer.isEditable();
      var enabled = isResizable || editable;
      var vectors = [];
      return _react2.default.createElement(
        'div',
        { style: Object.assign({ position: 'relative' }, style), className: 'o-layer o-layer-flexGrid' },
        _react2.default.createElement(
          _reactGridLayout2.default,
          { isDraggable: enabled, isResizable: enabled, cols: 12, rowHeight: 100, width: this.state.width },
          components.map(function (item, index) {
            var vector = item.attrs.vector;
            if (autoGrid) {
              if (!vector) {
                vector = item.attrs.vector = _this3.getGridVector(vectors);
              }
              vectors.push(vector);
            }
            return _react2.default.createElement(
              'div',
              { key: item.key || index, 'data-tt': 1, 'data-grid': vector },
              _react2.default.createElement(
                LayerItem,
                _extends({ onChange: onLayerChange }, item.attrs),
                item && item.component ? _react2.default.createElement(item.component, null) : null
              )
            );
          })
        )
      );
    }
  }]);

  return FlexGridLayer;
}(_react2.default.PureComponent), _class.contextTypes = {
  resizer: _propTypes2.default.object,
  layer: _propTypes2.default.object
}, _class.propTypes = {
  components: _propTypes2.default.array,
  LayerItem: _propTypes2.default.any,
  onLayerChange: _propTypes2.default.func,
  autoGrid: _propTypes2.default.bool,
  isResizable: _propTypes2.default.bool,
  style: _propTypes2.default.object
}, _temp2);


//////////////////
// WEBPACK FOOTER
// ./src/layers/flexGridLayer/index.jsx
// module id = 121
// module chunks = 0